import {Injectable} from "@angular/core";
import {EvkHttpService, EvkUpdateServiceBase} from "@evomatik/evk-common";
import {EvkExpedienteModel} from "../models/evk-expediente.model";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class ExpedienteUpdateService extends EvkUpdateServiceBase<EvkExpedienteModel> {
    
    url: string = "/seaged-expedientes-service/expediente";
    /** For dynamic expediente backend update service */
    constructor(h: EvkHttpService) {
        super(h);
    }

    set api(url: string){
        this.url = url;
    }

    get api(): string {
        return this.url
    }

    evkOnBeforeEdit(data: EvkExpedienteModel): Observable<EvkExpedienteModel> {
        return new Observable(
            (observer) => {
                observer.next();
            }
        );
    }

    evkOnDoneEdit(response: any): void {
    }

    evkOnErrorEdit(error: any): void {
    }
}
